// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3KVkZ","large":"styles_large__38WtN"};